module.exports = __webpack_public_path__ + "static/media/logo-transparent.da1f9f72.png";